import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule
} from 'vuex-module-decorators';

import OrderTrackingModel from '@/api/order-tracking/order-tracking.model';
import { orderTrackingService } from '@/api/order-tracking/order-tracking.service';
import StatusModel from '@/api/status/status.model';
import { statusService } from '@/api/status/status.service';
import { mainStore } from '@/modules/main/store';
import store from '@/plugins/store.plugin';

@Module({ dynamic: true, name: 'tracking-old', namespaced: true, store })
export default class Tracking extends VuexModule {
  private trackingData: OrderTrackingModel = null;
  private deliveryTrackingStatusList: StatusModel[] = null;

  get tracking() {
    return this.trackingData?.tracking;
  }

  get deliveryOrderCode() {
    return this.trackingData?.delivery?.orderCode;
  }

  get deliveryTrackingStatus() {
    return this.deliveryTrackingStatusList;
  }

  @Action({ commit: 'setTrackingData' })
  getData(trackingNumber: string): Promise<OrderTrackingModel> {
    return orderTrackingService.getById(trackingNumber);
  }

  @Action({ commit: 'setDeliveryTrackingStatus' })
  getDeliveryTrackingStatus(): Promise<StatusModel[]> {
    return statusService.getDeliveryTrackingStatus();
  }

  @Mutation
  setTrackingData(data: OrderTrackingModel) {
    this.trackingData = data;
    mainStore.setDeliveryData(data?.delivery);
  }

  @Mutation
  setDeliveryTrackingStatus(data: StatusModel[]) {
    this.deliveryTrackingStatusList = data;
  }
}

export const trackingOldStore = getModule(Tracking);
